import React from 'react';
import Loader from './loader';

class Section extends React.Component {
    constructor() {
        super();

		this.state = {
			error : null,
			isLoaded : false,
			data : []
        };
                
    }

	fetchData(url) {
		fetch(url, {
			headers: {
				"Content-Type": "application/json"
			  },			
		})
		    .then( response => response.json() )
			.then(
				(result) => {
					this.setState({
						isLoaded: true,
						data: result,

					});	
					//console.log(result);
				},
				// Note: it's important to handle errors here
        		// instead of a catch() block so that we don't swallow
        		// exceptions from actual bugs in components.
        		(error) => {
        			this.setState({
        				isLoading: false,
        				isLoaded: true,
        				error: error
        			});
        		}
		)
    }
    
	//	https://reactjs.org/docs/faq-ajax.html
	//	https://www.robinwieruch.de/react-fetching-data/
	componentDidMount() {
        this.fetchData(this.props.api_url)
    }   
	
	//pass props to children
	//https://stackoverflow.com/a/32371612
	render() {
		const { error, isLoaded, data } = this.state;

		/*

		Pass state as props to unknown children components

		https://stackoverflow.com/questions/32370994/how-to-pass-props-to-this-props-children
		https://codepen.io/Yuschick/post/react-passing-state-to-props-children-in-jsx
		https://stackoverflow.com/a/50294056
		
		see also this: 
		https://www.robinwieruch.de/react-render-props-pattern/ 
		https://www.robinwieruch.de/react-pass-props-to-component/
		
		for slight different approach

		
		TO DO: React.createContext (16.3)

		*/

		const childWithProp = React.Children.map(this.props.children, (child) => {
			return React.cloneElement(child, {data: this.state.data});
		});	

		if( error ) {
			return <div>Error: {error.message}</div>;
		} else if (!isLoaded) {
			return <Loader />;
		} else if( data ) {
			return (
				<React.Fragment>
					{childWithProp}
				</React.Fragment>
			)
		} else {
			//Fetch response is empty - component not rendered
			return null;
		}
	}    

}

export default Section;